/*
 * @Author: wyh
 * @Date: 2020-04-20 21:15:28
 * @Last Modified by: wyh
 * @Last Modified time: 2020-04-20 22:19:50
 */

import getApiHost from './getApiHost';
function getTenantId() {
  const re = /tenantId=(\d+)/.exec(window.location.href);
  if (re && re[1]) {
    return re[1];
  }
  return 800357;
}

const tenantId = getTenantId();
const baseURL = getApiHost();

export { getTenantId, tenantId, baseURL };
